"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.essShreddingModesFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dictionary_evidence_1 = require("../../../../composite/evidence/dictionary-evidence/dictionary-evidence");
const evidence_1 = require("../../../../composite/evidence/evidence");
const shredding_modes_fields_1 = require("./shredding-modes-fields");
const shredding_modes_columns_1 = require("./shredding-modes-columns");
function essShreddingModesFactory(url, reportTag) {
    return function ShreddingModes() {
        const intl = react_intl_1.useIntl();
        const evidence = dictionary_evidence_1.useDictionaryEvidence({
            identifier: 'ESS_SHREDDING_MODES',
            apiProps: {
                url,
            },
            tableProps: {
                columns: shredding_modes_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'ESS_SHREDDING_MODES_TABLE_TITLE',
                    defaultMessage: 'Skartačné režimy',
                }),
                reportTag,
            },
            detailProps: {
                FieldsComponent: shredding_modes_fields_1.ShreddingModesFields,
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.essShreddingModesFactory = essShreddingModesFactory;
//# sourceMappingURL=shredding-modes.js.map